export default "__VITE_ASSET__D1Vdq8Xu__"